import { memo, useCallback, useMemo, SyntheticEvent } from 'react';
import styled from '@emotion/styled';
import Select, { Option } from 'presentations/views/components/atoms/Select';
import { spacing } from 'presentations/views/styles';
import { DateTime, getDateTime } from 'infras/datetime';
const sprintf = require('sprintf-js').sprintf;

export interface Props {
  timeZone: string;
  className?: string;
  name?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  date?: DateTime | null;
  valueHour?: number | null;
  valueMinute?: number | null;
  selectable24hour?: boolean;
  onSelect?: (datetime: DateTime) => void;
}

const stringify = (hour: number, minute: number) => {
  return `${sprintf('%02d', hour)}:${sprintf('%02d', minute)}`;
};

const Component = memo((props: Props) => {
  const onChange = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      const time = e.currentTarget.value.split(':');
      const date = getDateTime(props.date, props.timeZone);
      props.onSelect &&
        props.onSelect(
          date.set({ hour: Number(time[0]), minute: Number(time[1]) }),
        );
    },
    [props.onSelect],
  );

  const options: Option[] = useMemo(() => {
    const newOptions: Option[] = [{ text: '', value: null }];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        const timeString = stringify(i, j);
        newOptions.push({ text: timeString, value: timeString });
      }
    }

    if (props.selectable24hour) {
      const timeString = stringify(24, 0);
      newOptions.push({ text: timeString, value: timeString });
    }
    return newOptions;
  }, [props.selectable24hour]);

  const value = useMemo(() => {
    let newValue = null;
    if (
      typeof props.valueHour === 'number' &&
      typeof props.valueMinute === 'number'
    ) {
      newValue = stringify(props.valueHour, props.valueMinute);
    }
    return newValue;
  }, [props.valueHour, props.valueMinute]);

  return (
    <Container>
      <StyledSelect
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={props.isDisabled}
        isLoading={props.isLoading}
        name={props.name}
        className={`time-picker ${props.className}`}
        variant="filled"
      />
    </Container>
  );
});
export default Component;

const Container = styled.div`
  & .MuiFormControl-root.time-picker {
    width: 80px;
  }
  & .MuiSelect-outlined.MuiSelect-outlined {
    background: none;
  }
  & .MuiFilledInput-input {
    padding: ${spacing(8)} ${spacing(32)} ${spacing(8)} ${spacing(12)};
  }
`;
const StyledSelect = styled(Select)``;
